<template>
  <div class="container">
    <v-data-table
        :headers="headers"
        :items="items"
        sort-by="calories"
        class="elevation-1"
        disable-pagination
        disable-filtering
        hide-default-footer>
      
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Καρτέλες</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>


          <v-dialog v-model="ledgerDialogOpen">
            <v-card>
              <v-card-title class="text-h5">Καρτέλα</v-card-title>
              <v-card-text>
                <v-data-table
                    v-bind:items="currentLedger.entries"
                    v-bind:headers="ledgerHeaders"
                    disable-pagination
                    disable-filtering
                    hide-default-footer
                    >
                  <template v-slot:[`item.debit`]="{ item }">
                    <span>{{ formatMoney(item.debit) }}</span>
                  </template>
                  <template v-slot:[`item.credit`]="{ item }">
                    <span>{{ formatMoney(item.credit) }}</span>
                  </template>
                  <template v-slot:[`item.oldBalance`]="{ item }">
                    <span>{{ formatMoney(item.oldBalance) }}</span>
                  </template>  
                  <template v-slot:[`item.newBalance`]="{ item }">
                    <span>{{ formatMoney(item.newBalance) }}</span>
                  </template>
                </v-data-table>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>



        </v-toolbar>
      </template>
      
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn text color="primary" class="mr-2" @click="showLedgerFor(item)"> ΚΑΡΤΕΛΑ </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    data: () => ({
      headers: [
        {
          text: 'Επωνυμία',
          align: 'start',
          //sortable: false,
          value: 'name',
        },
        { 
          text: 'ΑΦΜ', 
          value: 'tax_registration_number' 
        },
        { 
          text: 'Υπόλοιπο', 
          value: 'balance' 
        },
        { 
            text: 'Actions', 
            value: 'actions', 
            sortable: false 
        },
      ],

        ledgerHeaders: [
        {
            text: 'Ημερομηνία',
            value: 'date'
        },
        {
            text: 'Παραστατικό',
            value: 'documentTypeDescription'
        },
        {
            text: 'Αριθμός',
            value: 'documentNumber'
        },
        {
            text: 'Χρέωση',
            value: 'debit'
        },
        {
            text: 'Πίστωση',
            value: 'credit'
        },
        {
            text: 'Παλιό υπόλοιπο',
            value: 'oldBalance'
        },
        {
            text: 'Νέο υπόλοιπο',
            value: 'newBalance'
        },
    ],

      items: [],
      currentLedger: {},

      openLedgerButtonDisabled: false,
      ledgerDialogOpen: false,
    }),


    created () {
      this.initialize()
    },

    methods: {
      formatMoney(amount) {
        if (amount == null)
          amount = 0.0

        return amount.toFixed(2)
      },
      initialize () {
        
        axios.get('/api/accounts/active')
        .then(response => { this.items = response.data })
        .catch(error => { console.log(error) })

      },

      showLedgerFor(account) {
          axios.get(`/api/accounts/${account.id}/ledger`)
          .then(response => { this.currentLedger = response.data; this.ledgerDialogOpen = true })
          .catch(error => { console.log(error) })
      }
 
    },
  }
</script>

<style scoped>
.v-data-table-header th {
  white-space: nowrap;
}

th {
  vertical-align: top;
}
</style>